import styled from 'styled-components';
import background from './background.png';

export const Background = styled.div`
    background: #fff;
    background-image: url(${background});
    min-width: 100vw;
    min-height: 100vh;
    margin: 0;
`;

export const Container = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 0 2rem;
    margin: 0 auto;
`;

export const Main = styled.main`
    font-family: 'EB Garamond', serif;

    h1, h2 {
        font-family: 'Playfair Display', serif;
    }    
`;

